export enum ProductUploadMetricName {
  UPLOADS_STARTED = 'preowned_uploads_started_total',
  UPLOAD_METHOD_USED = 'preowned_upload_method_used_total',
  UPLOADS_COMPLETED = 'preowned_uploads_completed_total',
  UPLOADS_METHODS_SUMMARY = 'preowned_uploads_methods_summary_total',
  UPLOAD_METHOD_DURATION = 'preowned_upload_method_duration_seconds',
  UPLOAD_SIGNED_URL_RETRY = 'preowned_upload_signed_url_retry_total',
}